/* tslint:disable */
/* eslint-disable */
/**
 * Apono
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccessDetailsClientModel
 */
export interface AccessDetailsClientModel {
    /**
     * 
     * @type {string}
     * @memberof AccessDetailsClientModel
     */
    'plain': string;
    /**
     * 
     * @type {string}
     * @memberof AccessDetailsClientModel
     */
    'markdown': string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessDetailsClientModel
     */
    'can_reset_credentials': boolean;
}
/**
 * 
 * @export
 * @interface AccessGroupClientModel
 */
export interface AccessGroupClientModel {
    /**
     * 
     * @type {IntegrationClientModel}
     * @memberof AccessGroupClientModel
     */
    'integration': IntegrationClientModel;
    /**
     * 
     * @type {Array<ResourceTypeClientModel>}
     * @memberof AccessGroupClientModel
     */
    'resource_types': Array<ResourceTypeClientModel>;
    /**
     * 
     * @type {string}
     * @memberof AccessGroupClientModel
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessGroupClientModel
     */
    'has_new_credentials': boolean;
    /**
     * 
     * @type {AccessGroupStatusClientModel}
     * @memberof AccessGroupClientModel
     */
    'status': AccessGroupStatusClientModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AccessGroupStatus = {
    Success: 'Success',
    Failure: 'Failure',
    Warning: 'Warning'
} as const;

export type AccessGroupStatus = typeof AccessGroupStatus[keyof typeof AccessGroupStatus];


/**
 * 
 * @export
 * @interface AccessGroupStatusClientModel
 */
export interface AccessGroupStatusClientModel {
    /**
     * 
     * @type {AccessGroupStatus}
     * @memberof AccessGroupStatusClientModel
     */
    'status': AccessGroupStatus;
    /**
     * 
     * @type {string}
     * @memberof AccessGroupStatusClientModel
     */
    'message'?: string | null;
}


/**
 * 
 * @export
 * @interface AccessRequestClientModel
 */
export interface AccessRequestClientModel {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestClientModel
     */
    'id': string;
    /**
     * 
     * @type {UserClientModel}
     * @memberof AccessRequestClientModel
     */
    'requestor': UserClientModel;
    /**
     * 
     * @type {number}
     * @memberof AccessRequestClientModel
     */
    'creation_time': number;
    /**
     * 
     * @type {number}
     * @memberof AccessRequestClientModel
     */
    'revocation_time'?: number | null;
    /**
     * 
     * @type {RequestStatusClientModel}
     * @memberof AccessRequestClientModel
     */
    'status': RequestStatusClientModel;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestClientModel
     */
    'justification'?: string | null;
    /**
     * 
     * @type {Array<AccessGroupClientModel>}
     * @memberof AccessRequestClientModel
     */
    'access_groups': Array<AccessGroupClientModel>;
    /**
     * 
     * @type {AccessRequestClientModelBundle}
     * @memberof AccessRequestClientModel
     */
    'bundle'?: AccessRequestClientModelBundle | null;
    /**
     * 
     * @type {AccessRequestClientModelChallenge}
     * @memberof AccessRequestClientModel
     */
    'challenge'?: AccessRequestClientModelChallenge | null;
    /**
     * 
     * @type {number}
     * @memberof AccessRequestClientModel
     */
    'duration_in_sec'?: number | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AccessRequestClientModel
     */
    'custom_fields'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestClientModel
     */
    'require_approver_reason'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AccessRequestClientModelBundle
 */
export interface AccessRequestClientModelBundle {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestClientModelBundle
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestClientModelBundle
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AccessRequestClientModelChallenge
 */
export interface AccessRequestClientModelChallenge {
    /**
     * 
     * @type {ClientChallengeLogicalRelation}
     * @memberof AccessRequestClientModelChallenge
     */
    'logical_relation': ClientChallengeLogicalRelation;
    /**
     * 
     * @type {Array<ChallengeApproverClientModel>}
     * @memberof AccessRequestClientModelChallenge
     */
    'approvers': Array<ChallengeApproverClientModel>;
}


/**
 * 
 * @export
 * @interface AccessRequestSubmittedClientResponse
 */
export interface AccessRequestSubmittedClientResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessRequestSubmittedClientResponse
     */
    'request_ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestSubmittedClientResponse
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface AccessRequestTemplateClientModel
 */
export interface AccessRequestTemplateClientModel {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestTemplateClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestTemplateClientModel
     */
    'name': string;
    /**
     * 
     * @type {AccessRequestTemplateTypeClientModel}
     * @memberof AccessRequestTemplateClientModel
     */
    'type': AccessRequestTemplateTypeClientModel;
    /**
     * 
     * @type {Array<IntegrationClientModel>}
     * @memberof AccessRequestTemplateClientModel
     */
    'integrations': Array<IntegrationClientModel>;
    /**
     * 
     * @type {Array<ResourceTypeClientModel>}
     * @memberof AccessRequestTemplateClientModel
     */
    'resource_types': Array<ResourceTypeClientModel>;
    /**
     * 
     * @type {Array<ResourceClientModel>}
     * @memberof AccessRequestTemplateClientModel
     */
    'resources': Array<ResourceClientModel>;
    /**
     * 
     * @type {Array<PermissionClientModel>}
     * @memberof AccessRequestTemplateClientModel
     */
    'permissions': Array<PermissionClientModel>;
    /**
     * 
     * @type {number}
     * @memberof AccessRequestTemplateClientModel
     */
    'create_date': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AccessRequestTemplateTypeClientModel = {
    IntegrationRequest: 'IntegrationRequest'
} as const;

export type AccessRequestTemplateTypeClientModel = typeof AccessRequestTemplateTypeClientModel[keyof typeof AccessRequestTemplateTypeClientModel];


/**
 * 
 * @export
 * @interface AccessRequestsAffectedByMfa
 */
export interface AccessRequestsAffectedByMfa {
    /**
     * 
     * @type {number}
     * @memberof AccessRequestsAffectedByMfa
     */
    'total': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessRequestsAffectedByMfa
     */
    'access_requests_ids': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AccessRequestsScopeModel = {
    MyRequests: 'MyRequests',
    MyTasks: 'MyTasks'
} as const;

export type AccessRequestsScopeModel = typeof AccessRequestsScopeModel[keyof typeof AccessRequestsScopeModel];


/**
 * 
 * @export
 * @interface AccessSessionClientModel
 */
export interface AccessSessionClientModel {
    /**
     * 
     * @type {string}
     * @memberof AccessSessionClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccessSessionClientModel
     */
    'name': string;
    /**
     * 
     * @type {SessionTypeClientModel}
     * @memberof AccessSessionClientModel
     */
    'type': SessionTypeClientModel;
    /**
     * 
     * @type {IntegrationClientModel}
     * @memberof AccessSessionClientModel
     */
    'integration': IntegrationClientModel;
    /**
     * 
     * @type {AccessSessionClientModelCredentials}
     * @memberof AccessSessionClientModel
     */
    'credentials'?: AccessSessionClientModelCredentials | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionClientModel
     */
    'connection_methods': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccessSessionClientModel
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessSessionClientModel
     */
    'has_more_access_units': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccessSessionClientModel
     */
    'has_link_access_details'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AccessSessionClientModelCredentials
 */
export interface AccessSessionClientModelCredentials {
    /**
     * 
     * @type {string}
     * @memberof AccessSessionClientModelCredentials
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccessSessionClientModelCredentials
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessSessionClientModelCredentials
     */
    'can_reset': boolean;
}
/**
 * 
 * @export
 * @interface AccessSessionDetailsClientModel
 */
export interface AccessSessionDetailsClientModel {
    /**
     * 
     * @type {AccessSessionClientModelCredentials}
     * @memberof AccessSessionDetailsClientModel
     */
    'credentials'?: AccessSessionClientModelCredentials | null;
    /**
     * 
     * @type {InstructionClientModel}
     * @memberof AccessSessionDetailsClientModel
     */
    'instructions': InstructionClientModel;
    /**
     * 
     * @type {object}
     * @memberof AccessSessionDetailsClientModel
     */
    'json'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof AccessSessionDetailsClientModel
     */
    'cli'?: string | null;
    /**
     * 
     * @type {AccessSessionDetailsClientModelLink}
     * @memberof AccessSessionDetailsClientModel
     */
    'link'?: AccessSessionDetailsClientModelLink | null;
}
/**
 * 
 * @export
 * @interface AccessSessionDetailsClientModelLink
 */
export interface AccessSessionDetailsClientModelLink {
    /**
     * 
     * @type {string}
     * @memberof AccessSessionDetailsClientModelLink
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof AccessSessionDetailsClientModelLink
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface AccessSessionRequestTemplateClientModel
 */
export interface AccessSessionRequestTemplateClientModel {
    /**
     * 
     * @type {Array<IntegrationClientModel>}
     * @memberof AccessSessionRequestTemplateClientModel
     */
    'integrations': Array<IntegrationClientModel>;
    /**
     * 
     * @type {Array<ResourceTypeClientModel>}
     * @memberof AccessSessionRequestTemplateClientModel
     */
    'resource_types': Array<ResourceTypeClientModel>;
    /**
     * 
     * @type {Array<ResourceClientModel>}
     * @memberof AccessSessionRequestTemplateClientModel
     */
    'resources': Array<ResourceClientModel>;
    /**
     * 
     * @type {Array<PermissionClientModel>}
     * @memberof AccessSessionRequestTemplateClientModel
     */
    'permissions': Array<PermissionClientModel>;
}
/**
 * 
 * @export
 * @interface AccessSessionsGroupClientModel
 */
export interface AccessSessionsGroupClientModel {
    /**
     * 
     * @type {AccessSessionsGroupClientModelIntegration}
     * @memberof AccessSessionsGroupClientModel
     */
    'integration'?: AccessSessionsGroupClientModelIntegration | null;
    /**
     * 
     * @type {number}
     * @memberof AccessSessionsGroupClientModel
     */
    'total': number;
    /**
     * 
     * @type {Array<AccessSessionClientModel>}
     * @memberof AccessSessionsGroupClientModel
     */
    'sessions': Array<AccessSessionClientModel>;
}
/**
 * 
 * @export
 * @interface AccessSessionsGroupClientModelIntegration
 */
export interface AccessSessionsGroupClientModelIntegration {
    /**
     * 
     * @type {string}
     * @memberof AccessSessionsGroupClientModelIntegration
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccessSessionsGroupClientModelIntegration
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof AccessSessionsGroupClientModelIntegration
     */
    'type_display_name': string;
    /**
     * 
     * @type {string}
     * @memberof AccessSessionsGroupClientModelIntegration
     */
    'name': string;
    /**
     * 
     * @type {IconsConfigClientModel}
     * @memberof AccessSessionsGroupClientModelIntegration
     */
    'icons': IconsConfigClientModel;
}
/**
 * 
 * @export
 * @interface AccessUnitClientModel
 */
export interface AccessUnitClientModel {
    /**
     * 
     * @type {string}
     * @memberof AccessUnitClientModel
     */
    'id': string;
    /**
     * 
     * @type {ResourceClientModel}
     * @memberof AccessUnitClientModel
     */
    'resource': ResourceClientModel;
    /**
     * 
     * @type {PermissionClientModel}
     * @memberof AccessUnitClientModel
     */
    'permission': PermissionClientModel;
    /**
     * 
     * @type {AccessUnitClientModelStatus}
     * @memberof AccessUnitClientModel
     */
    'status'?: AccessUnitClientModelStatus | null;
}
/**
 * 
 * @export
 * @interface AccessUnitClientModelStatus
 */
export interface AccessUnitClientModelStatus {
    /**
     * 
     * @type {string}
     * @memberof AccessUnitClientModelStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof AccessUnitClientModelStatus
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface AccessUnitStatusClientModel
 */
export interface AccessUnitStatusClientModel {
    /**
     * 
     * @type {string}
     * @memberof AccessUnitStatusClientModel
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof AccessUnitStatusClientModel
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface AccountClientModel
 */
export interface AccountClientModel {
    /**
     * 
     * @type {string}
     * @memberof AccountClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountClientModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AccountClientModel
     */
    'plan': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AnalyticClientTypeClientModel = {
    Cli: 'CLI'
} as const;

export type AnalyticClientTypeClientModel = typeof AnalyticClientTypeClientModel[keyof typeof AnalyticClientTypeClientModel];


/**
 * 
 * @export
 * @interface ApprovalResultClientModel
 */
export interface ApprovalResultClientModel {
    /**
     * 
     * @type {string}
     * @memberof ApprovalResultClientModel
     */
    'justification'?: string | null;
}
/**
 * 
 * @export
 * @interface BundleClientModel
 */
export interface BundleClientModel {
    /**
     * 
     * @type {string}
     * @memberof BundleClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BundleClientModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ChallengeApproverClientModel
 */
export interface ChallengeApproverClientModel {
    /**
     * 
     * @type {string}
     * @memberof ChallengeApproverClientModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeApproverClientModel
     */
    'type': string;
    /**
     * 
     * @type {ClientChallengeStatus}
     * @memberof ChallengeApproverClientModel
     */
    'status': ClientChallengeStatus;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ChallengeApproverClientModel
     */
    'metadata': { [key: string]: string; };
}


/**
 * 
 * @export
 * @interface ChallengeInfoClientModel
 */
export interface ChallengeInfoClientModel {
    /**
     * 
     * @type {ClientChallengeLogicalRelation}
     * @memberof ChallengeInfoClientModel
     */
    'logical_relation': ClientChallengeLogicalRelation;
    /**
     * 
     * @type {Array<ChallengeApproverClientModel>}
     * @memberof ChallengeInfoClientModel
     */
    'approvers': Array<ChallengeApproverClientModel>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ClientChallengeLogicalRelation = {
    AnyOf: 'AnyOf',
    AllOf: 'AllOf'
} as const;

export type ClientChallengeLogicalRelation = typeof ClientChallengeLogicalRelation[keyof typeof ClientChallengeLogicalRelation];


/**
 * 
 * @export
 * @enum {string}
 */

export const ClientChallengeStatus = {
    Approved: 'Approved',
    Rejected: 'Rejected',
    Pending: 'Pending'
} as const;

export type ClientChallengeStatus = typeof ClientChallengeStatus[keyof typeof ClientChallengeStatus];


/**
 * 
 * @export
 * @interface CreateAccessRequestClientModel
 */
export interface CreateAccessRequestClientModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAccessRequestClientModel
     */
    'filter_integration_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAccessRequestClientModel
     */
    'filter_bundle_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAccessRequestClientModel
     */
    'filter_resource_type_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAccessRequestClientModel
     */
    'filter_resource_ids': Array<string>;
    /**
     * 
     * @type {Array<ResourceFilter>}
     * @memberof CreateAccessRequestClientModel
     */
    'filter_resources': Array<ResourceFilter>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAccessRequestClientModel
     */
    'filter_permission_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAccessRequestClientModel
     */
    'filter_access_unit_ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRequestClientModel
     */
    'justification'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAccessRequestClientModel
     */
    'duration_in_sec'?: number | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateAccessRequestClientModel
     */
    'custom_fields'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccessRequestClientModel
     */
    'run_pre_approval_validations'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CreateAnalyticEventClientModel
 */
export interface CreateAnalyticEventClientModel {
    /**
     * 
     * @type {string}
     * @memberof CreateAnalyticEventClientModel
     */
    'event_name': string;
    /**
     * 
     * @type {AnalyticClientTypeClientModel}
     * @memberof CreateAnalyticEventClientModel
     */
    'client_type': AnalyticClientTypeClientModel;
    /**
     * 
     * @type {object}
     * @memberof CreateAnalyticEventClientModel
     */
    'properties': object;
}


/**
 * 
 * @export
 * @interface CreateAndUpdateAccessRequestTemplateClientModel
 */
export interface CreateAndUpdateAccessRequestTemplateClientModel {
    /**
     * 
     * @type {string}
     * @memberof CreateAndUpdateAccessRequestTemplateClientModel
     */
    'name': string;
    /**
     * 
     * @type {AccessRequestTemplateTypeClientModel}
     * @memberof CreateAndUpdateAccessRequestTemplateClientModel
     */
    'type': AccessRequestTemplateTypeClientModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAndUpdateAccessRequestTemplateClientModel
     */
    'filter_integration_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAndUpdateAccessRequestTemplateClientModel
     */
    'filter_resource_type_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAndUpdateAccessRequestTemplateClientModel
     */
    'filter_resource_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAndUpdateAccessRequestTemplateClientModel
     */
    'filter_permission_ids': Array<string>;
}


/**
 * 
 * @export
 * @interface CreateUserPersonalTokenRequestClientModel
 */
export interface CreateUserPersonalTokenRequestClientModel {
    /**
     * 
     * @type {string}
     * @memberof CreateUserPersonalTokenRequestClientModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserPersonalTokenRequestClientModel
     */
    'expiry_date'?: number | null;
}
/**
 * 
 * @export
 * @interface CredentialsClientModel
 */
export interface CredentialsClientModel {
    /**
     * 
     * @type {string}
     * @memberof CredentialsClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CredentialsClientModel
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof CredentialsClientModel
     */
    'can_reset': boolean;
}
/**
 * 
 * @export
 * @interface DryRunAccessRequestError
 */
export interface DryRunAccessRequestError {
    /**
     * 
     * @type {string}
     * @memberof DryRunAccessRequestError
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof DryRunAccessRequestError
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof DryRunAccessRequestError
     */
    'message'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DryRunAccessRequestError
     */
    'details': object;
}
/**
 * 
 * @export
 * @interface DryRunClientResponse
 */
export interface DryRunClientResponse {
    /**
     * 
     * @type {string}
     * @memberof DryRunClientResponse
     */
    'status': string;
    /**
     * 
     * @type {Array<DryRunAccessRequestError>}
     * @memberof DryRunClientResponse
     */
    'errors': Array<DryRunAccessRequestError>;
}
/**
 * 
 * @export
 * @interface IconsConfigClientModel
 */
export interface IconsConfigClientModel {
    /**
     * 
     * @type {string}
     * @memberof IconsConfigClientModel
     */
    'png': string;
    /**
     * 
     * @type {string}
     * @memberof IconsConfigClientModel
     */
    'svg': string;
}
/**
 * 
 * @export
 * @interface InstructionClientModel
 */
export interface InstructionClientModel {
    /**
     * 
     * @type {string}
     * @memberof InstructionClientModel
     */
    'plain': string;
    /**
     * 
     * @type {string}
     * @memberof InstructionClientModel
     */
    'markdown': string;
    /**
     * 
     * @type {string}
     * @memberof InstructionClientModel
     */
    'custom_message'?: string | null;
}
/**
 * 
 * @export
 * @interface IntegrationClientModel
 */
export interface IntegrationClientModel {
    /**
     * 
     * @type {string}
     * @memberof IntegrationClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationClientModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationClientModel
     */
    'type_display_name': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationClientModel
     */
    'name': string;
    /**
     * 
     * @type {IconsConfigClientModel}
     * @memberof IntegrationClientModel
     */
    'icons': IconsConfigClientModel;
}
/**
 * 
 * @export
 * @interface LinkClientModel
 */
export interface LinkClientModel {
    /**
     * 
     * @type {string}
     * @memberof LinkClientModel
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof LinkClientModel
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface MessageResponse
 */
export interface MessageResponse {
    /**
     * 
     * @type {string}
     * @memberof MessageResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelAccessRequestClientModel
 */
export interface PaginatedClientResponseModelAccessRequestClientModel {
    /**
     * 
     * @type {Array<AccessRequestClientModel>}
     * @memberof PaginatedClientResponseModelAccessRequestClientModel
     */
    'data': Array<AccessRequestClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelAccessRequestClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelAccessRequestTemplateClientModel
 */
export interface PaginatedClientResponseModelAccessRequestTemplateClientModel {
    /**
     * 
     * @type {Array<AccessRequestTemplateClientModel>}
     * @memberof PaginatedClientResponseModelAccessRequestTemplateClientModel
     */
    'data': Array<AccessRequestTemplateClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelAccessRequestTemplateClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelAccessSessionClientModel
 */
export interface PaginatedClientResponseModelAccessSessionClientModel {
    /**
     * 
     * @type {Array<AccessSessionClientModel>}
     * @memberof PaginatedClientResponseModelAccessSessionClientModel
     */
    'data': Array<AccessSessionClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelAccessSessionClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelAccessSessionsGroupClientModel
 */
export interface PaginatedClientResponseModelAccessSessionsGroupClientModel {
    /**
     * 
     * @type {Array<AccessSessionsGroupClientModel>}
     * @memberof PaginatedClientResponseModelAccessSessionsGroupClientModel
     */
    'data': Array<AccessSessionsGroupClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelAccessSessionsGroupClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelAccessUnitClientModel
 */
export interface PaginatedClientResponseModelAccessUnitClientModel {
    /**
     * 
     * @type {Array<AccessUnitClientModel>}
     * @memberof PaginatedClientResponseModelAccessUnitClientModel
     */
    'data': Array<AccessUnitClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelAccessUnitClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelBundleClientModel
 */
export interface PaginatedClientResponseModelBundleClientModel {
    /**
     * 
     * @type {Array<BundleClientModel>}
     * @memberof PaginatedClientResponseModelBundleClientModel
     */
    'data': Array<BundleClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelBundleClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelIntegrationClientModel
 */
export interface PaginatedClientResponseModelIntegrationClientModel {
    /**
     * 
     * @type {Array<IntegrationClientModel>}
     * @memberof PaginatedClientResponseModelIntegrationClientModel
     */
    'data': Array<IntegrationClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelIntegrationClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelPermissionClientModel
 */
export interface PaginatedClientResponseModelPermissionClientModel {
    /**
     * 
     * @type {Array<PermissionClientModel>}
     * @memberof PaginatedClientResponseModelPermissionClientModel
     */
    'data': Array<PermissionClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelPermissionClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelResourceClientModel
 */
export interface PaginatedClientResponseModelResourceClientModel {
    /**
     * 
     * @type {Array<ResourceClientModel>}
     * @memberof PaginatedClientResponseModelResourceClientModel
     */
    'data': Array<ResourceClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelResourceClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginatedClientResponseModelResourceTypeClientModel
 */
export interface PaginatedClientResponseModelResourceTypeClientModel {
    /**
     * 
     * @type {Array<ResourceTypeClientModel>}
     * @memberof PaginatedClientResponseModelResourceTypeClientModel
     */
    'data': Array<ResourceTypeClientModel>;
    /**
     * 
     * @type {PaginationClientInfoModel}
     * @memberof PaginatedClientResponseModelResourceTypeClientModel
     */
    'pagination': PaginationClientInfoModel;
}
/**
 * 
 * @export
 * @interface PaginationClientInfoModel
 */
export interface PaginationClientInfoModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationClientInfoModel
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationClientInfoModel
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationClientInfoModel
     */
    'total'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationClientInfoModel
     */
    'has_more'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PassMfaClientResponse
 */
export interface PassMfaClientResponse {
    /**
     * 
     * @type {string}
     * @memberof PassMfaClientResponse
     */
    'message': string;
    /**
     * 
     * @type {AccessRequestsAffectedByMfa}
     * @memberof PassMfaClientResponse
     */
    'affected_requests': AccessRequestsAffectedByMfa;
}
/**
 * 
 * @export
 * @interface PermissionClientModel
 */
export interface PermissionClientModel {
    /**
     * 
     * @type {string}
     * @memberof PermissionClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PermissionClientModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RequestAgainClientModel
 */
export interface RequestAgainClientModel {
    /**
     * 
     * @type {string}
     * @memberof RequestAgainClientModel
     */
    'justification': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RequestAgainClientModel
     */
    'custom_fields'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof RequestAgainClientModel
     */
    'run_pre_approval_validations'?: boolean | null;
}
/**
 * 
 * @export
 * @interface RequestCustomFieldModel
 */
export interface RequestCustomFieldModel {
    /**
     * 
     * @type {string}
     * @memberof RequestCustomFieldModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RequestCustomFieldModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof RequestCustomFieldModel
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof RequestCustomFieldModel
     */
    'placeholder': string;
    /**
     * 
     * @type {Array<RequestCustomFieldValueModel>}
     * @memberof RequestCustomFieldModel
     */
    'values': Array<RequestCustomFieldValueModel>;
    /**
     * 
     * @type {string}
     * @memberof RequestCustomFieldModel
     */
    'default'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCustomFieldModel
     */
    'required': boolean;
}
/**
 * 
 * @export
 * @interface RequestCustomFieldValueModel
 */
export interface RequestCustomFieldValueModel {
    /**
     * 
     * @type {string}
     * @memberof RequestCustomFieldValueModel
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof RequestCustomFieldValueModel
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface RequestStatusClientModel
 */
export interface RequestStatusClientModel {
    /**
     * 
     * @type {string}
     * @memberof RequestStatusClientModel
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof RequestStatusClientModel
     */
    'description'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RequestStatusClientModel
     */
    'metadata': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface ResourceClientModel
 */
export interface ResourceClientModel {
    /**
     * 
     * @type {string}
     * @memberof ResourceClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceClientModel
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceClientModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceClientModel
     */
    'path': string;
    /**
     * 
     * @type {ResourceTypeClientModel}
     * @memberof ResourceClientModel
     */
    'type': ResourceTypeClientModel;
    /**
     * 
     * @type {IntegrationClientModel}
     * @memberof ResourceClientModel
     */
    'integration': IntegrationClientModel;
}
/**
 * 
 * @export
 * @interface ResourceFilter
 */
export interface ResourceFilter {
    /**
     * 
     * @type {ResourceFilterType}
     * @memberof ResourceFilter
     */
    'type': ResourceFilterType;
    /**
     * 
     * @type {string}
     * @memberof ResourceFilter
     */
    'value': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ResourceFilterType = {
    Id: 'id',
    SearchTerm: 'search_term'
} as const;

export type ResourceFilterType = typeof ResourceFilterType[keyof typeof ResourceFilterType];


/**
 * 
 * @export
 * @interface ResourceTypeClientModel
 */
export interface ResourceTypeClientModel {
    /**
     * 
     * @type {string}
     * @memberof ResourceTypeClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceTypeClientModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceTypeClientModel
     */
    'display_path': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResourceTypeClientModel
     */
    'allow_multiple_permissions': boolean;
    /**
     * 
     * @type {IconsConfigClientModel}
     * @memberof ResourceTypeClientModel
     */
    'icons': IconsConfigClientModel;
}
/**
 * 
 * @export
 * @interface SessionTypeClientModel
 */
export interface SessionTypeClientModel {
    /**
     * 
     * @type {string}
     * @memberof SessionTypeClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionTypeClientModel
     */
    'name': string;
    /**
     * 
     * @type {IconsConfigClientModel}
     * @memberof SessionTypeClientModel
     */
    'icons': IconsConfigClientModel;
}
/**
 * 
 * @export
 * @interface Unmasked
 */
export interface Unmasked {
    /**
     * 
     * @type {string}
     * @memberof Unmasked
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Unmasked
     */
    'account_id': string;
    /**
     * 
     * @type {string}
     * @memberof Unmasked
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof Unmasked
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Unmasked
     */
    'token': string;
    /**
     * 
     * @type {number}
     * @memberof Unmasked
     */
    'expiry_date'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Unmasked
     */
    'created_date': number;
}
/**
 * 
 * @export
 * @interface UpdateExpiryRequestClientModel
 */
export interface UpdateExpiryRequestClientModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateExpiryRequestClientModel
     */
    'expiry_date'?: number | null;
}
/**
 * 
 * @export
 * @interface UserClientModel
 */
export interface UserClientModel {
    /**
     * 
     * @type {string}
     * @memberof UserClientModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserClientModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserClientModel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserClientModel
     */
    'photo'?: string | null;
}
/**
 * 
 * @export
 * @interface UserMfaEnrolledResponse
 */
export interface UserMfaEnrolledResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserMfaEnrolledResponse
     */
    'is_mfa_enrolled': boolean;
}
/**
 * 
 * @export
 * @interface UserPersonalToken
 */
export interface UserPersonalToken {
    /**
     * 
     * @type {string}
     * @memberof UserPersonalToken
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserPersonalToken
     */
    'account_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserPersonalToken
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserPersonalToken
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserPersonalToken
     */
    'masked_token': string;
    /**
     * 
     * @type {number}
     * @memberof UserPersonalToken
     */
    'expiry_date'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserPersonalToken
     */
    'created_date': number;
}
/**
 * 
 * @export
 * @interface UserSessionClientModel
 */
export interface UserSessionClientModel {
    /**
     * 
     * @type {UserClientModel}
     * @memberof UserSessionClientModel
     */
    'user': UserClientModel;
    /**
     * 
     * @type {AccountClientModel}
     * @memberof UserSessionClientModel
     */
    'account': AccountClientModel;
    /**
     * 
     * @type {UserSettingsClientModel}
     * @memberof UserSessionClientModel
     */
    'settings': UserSettingsClientModel;
}
/**
 * 
 * @export
 * @interface UserSettingsClientModel
 */
export interface UserSettingsClientModel {
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsClientModel
     */
    'require_duration_for_access_request': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsClientModel
     */
    'mfa_enabled_for_account': boolean;
    /**
     * 
     * @type {Array<RequestCustomFieldModel>}
     * @memberof UserSettingsClientModel
     */
    'request_custom_fields': Array<RequestCustomFieldModel>;
}

/**
 * AccessGroupsApi - axios parameter creator
 * @export
 */
export const AccessGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get access group details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessGroupDetails: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccessGroupDetails', 'id', id)
            const localVarPath = `/api/client/v1/access-groups/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get access group units
         * @param {string} id 
         * @param {Array<string>} [integrationIds] 
         * @param {number} [limit] 
         * @param {Array<string>} [resourceTypeIds] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessGroupUnits: async (id: string, integrationIds?: Array<string>, limit?: number, resourceTypeIds?: Array<string>, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccessGroupUnits', 'id', id)
            const localVarPath = `/api/client/v1/access-groups/{id}/units`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationIds) {
                localVarQueryParameter['integration-ids'] = integrationIds;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (resourceTypeIds) {
                localVarQueryParameter['resource-type-ids'] = resourceTypeIds;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset access group credentials
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAccessGroupCredentials: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetAccessGroupCredentials', 'id', id)
            const localVarPath = `/api/client/v1/access-groups/{id}/reset`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessGroupsApi - functional programming interface
 * @export
 */
export const AccessGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get access group details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessGroupDetails(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessDetailsClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessGroupDetails(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get access group units
         * @param {string} id 
         * @param {Array<string>} [integrationIds] 
         * @param {number} [limit] 
         * @param {Array<string>} [resourceTypeIds] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessGroupUnits(id: string, integrationIds?: Array<string>, limit?: number, resourceTypeIds?: Array<string>, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelAccessUnitClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessGroupUnits(id, integrationIds, limit, resourceTypeIds, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset access group credentials
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetAccessGroupCredentials(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetAccessGroupCredentials(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccessGroupsApi - factory interface
 * @export
 */
export const AccessGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get access group details
         * @param {AccessGroupsApiGetAccessGroupDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessGroupDetails(requestParameters: AccessGroupsApiGetAccessGroupDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<AccessDetailsClientModel> {
            return localVarFp.getAccessGroupDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get access group units
         * @param {AccessGroupsApiGetAccessGroupUnitsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessGroupUnits(requestParameters: AccessGroupsApiGetAccessGroupUnitsRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelAccessUnitClientModel> {
            return localVarFp.getAccessGroupUnits(requestParameters.id, requestParameters.integrationIds, requestParameters.limit, requestParameters.resourceTypeIds, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset access group credentials
         * @param {AccessGroupsApiResetAccessGroupCredentialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAccessGroupCredentials(requestParameters: AccessGroupsApiResetAccessGroupCredentialsRequest, options?: AxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.resetAccessGroupCredentials(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAccessGroupDetails operation in AccessGroupsApi.
 * @export
 * @interface AccessGroupsApiGetAccessGroupDetailsRequest
 */
export interface AccessGroupsApiGetAccessGroupDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessGroupsApiGetAccessGroupDetails
     */
    readonly id: string
}

/**
 * Request parameters for getAccessGroupUnits operation in AccessGroupsApi.
 * @export
 * @interface AccessGroupsApiGetAccessGroupUnitsRequest
 */
export interface AccessGroupsApiGetAccessGroupUnitsRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessGroupsApiGetAccessGroupUnits
     */
    readonly id: string

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessGroupsApiGetAccessGroupUnits
     */
    readonly integrationIds?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof AccessGroupsApiGetAccessGroupUnits
     */
    readonly limit?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessGroupsApiGetAccessGroupUnits
     */
    readonly resourceTypeIds?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof AccessGroupsApiGetAccessGroupUnits
     */
    readonly skip?: number
}

/**
 * Request parameters for resetAccessGroupCredentials operation in AccessGroupsApi.
 * @export
 * @interface AccessGroupsApiResetAccessGroupCredentialsRequest
 */
export interface AccessGroupsApiResetAccessGroupCredentialsRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessGroupsApiResetAccessGroupCredentials
     */
    readonly id: string
}

/**
 * AccessGroupsApi - object-oriented interface
 * @export
 * @class AccessGroupsApi
 * @extends {BaseAPI}
 */
export class AccessGroupsApi extends BaseAPI {
    /**
     * 
     * @summary Get access group details
     * @param {AccessGroupsApiGetAccessGroupDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessGroupsApi
     */
    public getAccessGroupDetails(requestParameters: AccessGroupsApiGetAccessGroupDetailsRequest, options?: AxiosRequestConfig) {
        return AccessGroupsApiFp(this.configuration).getAccessGroupDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get access group units
     * @param {AccessGroupsApiGetAccessGroupUnitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessGroupsApi
     */
    public getAccessGroupUnits(requestParameters: AccessGroupsApiGetAccessGroupUnitsRequest, options?: AxiosRequestConfig) {
        return AccessGroupsApiFp(this.configuration).getAccessGroupUnits(requestParameters.id, requestParameters.integrationIds, requestParameters.limit, requestParameters.resourceTypeIds, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset access group credentials
     * @param {AccessGroupsApiResetAccessGroupCredentialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessGroupsApi
     */
    public resetAccessGroupCredentials(requestParameters: AccessGroupsApiResetAccessGroupCredentialsRequest, options?: AxiosRequestConfig) {
        return AccessGroupsApiFp(this.configuration).resetAccessGroupCredentials(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccessRequestTemplatesApi - axios parameter creator
 * @export
 */
export const AccessRequestTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create access request template
         * @param {CreateAndUpdateAccessRequestTemplateClientModel} createAndUpdateAccessRequestTemplateClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessRequestTemplate: async (createAndUpdateAccessRequestTemplateClientModel: CreateAndUpdateAccessRequestTemplateClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAndUpdateAccessRequestTemplateClientModel' is not null or undefined
            assertParamExists('createAccessRequestTemplate', 'createAndUpdateAccessRequestTemplateClientModel', createAndUpdateAccessRequestTemplateClientModel)
            const localVarPath = `/api/client/v1/access-request-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAndUpdateAccessRequestTemplateClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete access request template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessRequestTemplate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAccessRequestTemplate', 'id', id)
            const localVarPath = `/api/client/v1/access-request-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get access request template by ID
         * @param {string} id 
         * @param {boolean} [filterAvailable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequestTemplate: async (id: string, filterAvailable?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccessRequestTemplate', 'id', id)
            const localVarPath = `/api/client/v1/access-request-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filterAvailable !== undefined) {
                localVarQueryParameter['filter-available'] = filterAvailable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List access request templates
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessRequestTemplates: async (limit?: number, search?: string, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/access-request-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update access request template
         * @param {string} id 
         * @param {CreateAndUpdateAccessRequestTemplateClientModel} createAndUpdateAccessRequestTemplateClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessRequestTemplate: async (id: string, createAndUpdateAccessRequestTemplateClientModel: CreateAndUpdateAccessRequestTemplateClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAccessRequestTemplate', 'id', id)
            // verify required parameter 'createAndUpdateAccessRequestTemplateClientModel' is not null or undefined
            assertParamExists('updateAccessRequestTemplate', 'createAndUpdateAccessRequestTemplateClientModel', createAndUpdateAccessRequestTemplateClientModel)
            const localVarPath = `/api/client/v1/access-request-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAndUpdateAccessRequestTemplateClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessRequestTemplatesApi - functional programming interface
 * @export
 */
export const AccessRequestTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessRequestTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create access request template
         * @param {CreateAndUpdateAccessRequestTemplateClientModel} createAndUpdateAccessRequestTemplateClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccessRequestTemplate(createAndUpdateAccessRequestTemplateClientModel: CreateAndUpdateAccessRequestTemplateClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestTemplateClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccessRequestTemplate(createAndUpdateAccessRequestTemplateClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete access request template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccessRequestTemplate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccessRequestTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get access request template by ID
         * @param {string} id 
         * @param {boolean} [filterAvailable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessRequestTemplate(id: string, filterAvailable?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestTemplateClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessRequestTemplate(id, filterAvailable, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List access request templates
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessRequestTemplates(limit?: number, search?: string, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelAccessRequestTemplateClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessRequestTemplates(limit, search, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update access request template
         * @param {string} id 
         * @param {CreateAndUpdateAccessRequestTemplateClientModel} createAndUpdateAccessRequestTemplateClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccessRequestTemplate(id: string, createAndUpdateAccessRequestTemplateClientModel: CreateAndUpdateAccessRequestTemplateClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestTemplateClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccessRequestTemplate(id, createAndUpdateAccessRequestTemplateClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccessRequestTemplatesApi - factory interface
 * @export
 */
export const AccessRequestTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessRequestTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create access request template
         * @param {AccessRequestTemplatesApiCreateAccessRequestTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessRequestTemplate(requestParameters: AccessRequestTemplatesApiCreateAccessRequestTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<AccessRequestTemplateClientModel> {
            return localVarFp.createAccessRequestTemplate(requestParameters.createAndUpdateAccessRequestTemplateClientModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete access request template
         * @param {AccessRequestTemplatesApiDeleteAccessRequestTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessRequestTemplate(requestParameters: AccessRequestTemplatesApiDeleteAccessRequestTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.deleteAccessRequestTemplate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get access request template by ID
         * @param {AccessRequestTemplatesApiGetAccessRequestTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequestTemplate(requestParameters: AccessRequestTemplatesApiGetAccessRequestTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<AccessRequestTemplateClientModel> {
            return localVarFp.getAccessRequestTemplate(requestParameters.id, requestParameters.filterAvailable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List access request templates
         * @param {AccessRequestTemplatesApiListAccessRequestTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessRequestTemplates(requestParameters: AccessRequestTemplatesApiListAccessRequestTemplatesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelAccessRequestTemplateClientModel> {
            return localVarFp.listAccessRequestTemplates(requestParameters.limit, requestParameters.search, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update access request template
         * @param {AccessRequestTemplatesApiUpdateAccessRequestTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessRequestTemplate(requestParameters: AccessRequestTemplatesApiUpdateAccessRequestTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<AccessRequestTemplateClientModel> {
            return localVarFp.updateAccessRequestTemplate(requestParameters.id, requestParameters.createAndUpdateAccessRequestTemplateClientModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAccessRequestTemplate operation in AccessRequestTemplatesApi.
 * @export
 * @interface AccessRequestTemplatesApiCreateAccessRequestTemplateRequest
 */
export interface AccessRequestTemplatesApiCreateAccessRequestTemplateRequest {
    /**
     * 
     * @type {CreateAndUpdateAccessRequestTemplateClientModel}
     * @memberof AccessRequestTemplatesApiCreateAccessRequestTemplate
     */
    readonly createAndUpdateAccessRequestTemplateClientModel: CreateAndUpdateAccessRequestTemplateClientModel
}

/**
 * Request parameters for deleteAccessRequestTemplate operation in AccessRequestTemplatesApi.
 * @export
 * @interface AccessRequestTemplatesApiDeleteAccessRequestTemplateRequest
 */
export interface AccessRequestTemplatesApiDeleteAccessRequestTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestTemplatesApiDeleteAccessRequestTemplate
     */
    readonly id: string
}

/**
 * Request parameters for getAccessRequestTemplate operation in AccessRequestTemplatesApi.
 * @export
 * @interface AccessRequestTemplatesApiGetAccessRequestTemplateRequest
 */
export interface AccessRequestTemplatesApiGetAccessRequestTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestTemplatesApiGetAccessRequestTemplate
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestTemplatesApiGetAccessRequestTemplate
     */
    readonly filterAvailable?: boolean
}

/**
 * Request parameters for listAccessRequestTemplates operation in AccessRequestTemplatesApi.
 * @export
 * @interface AccessRequestTemplatesApiListAccessRequestTemplatesRequest
 */
export interface AccessRequestTemplatesApiListAccessRequestTemplatesRequest {
    /**
     * 
     * @type {number}
     * @memberof AccessRequestTemplatesApiListAccessRequestTemplates
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof AccessRequestTemplatesApiListAccessRequestTemplates
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof AccessRequestTemplatesApiListAccessRequestTemplates
     */
    readonly skip?: number
}

/**
 * Request parameters for updateAccessRequestTemplate operation in AccessRequestTemplatesApi.
 * @export
 * @interface AccessRequestTemplatesApiUpdateAccessRequestTemplateRequest
 */
export interface AccessRequestTemplatesApiUpdateAccessRequestTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestTemplatesApiUpdateAccessRequestTemplate
     */
    readonly id: string

    /**
     * 
     * @type {CreateAndUpdateAccessRequestTemplateClientModel}
     * @memberof AccessRequestTemplatesApiUpdateAccessRequestTemplate
     */
    readonly createAndUpdateAccessRequestTemplateClientModel: CreateAndUpdateAccessRequestTemplateClientModel
}

/**
 * AccessRequestTemplatesApi - object-oriented interface
 * @export
 * @class AccessRequestTemplatesApi
 * @extends {BaseAPI}
 */
export class AccessRequestTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Create access request template
     * @param {AccessRequestTemplatesApiCreateAccessRequestTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestTemplatesApi
     */
    public createAccessRequestTemplate(requestParameters: AccessRequestTemplatesApiCreateAccessRequestTemplateRequest, options?: AxiosRequestConfig) {
        return AccessRequestTemplatesApiFp(this.configuration).createAccessRequestTemplate(requestParameters.createAndUpdateAccessRequestTemplateClientModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete access request template
     * @param {AccessRequestTemplatesApiDeleteAccessRequestTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestTemplatesApi
     */
    public deleteAccessRequestTemplate(requestParameters: AccessRequestTemplatesApiDeleteAccessRequestTemplateRequest, options?: AxiosRequestConfig) {
        return AccessRequestTemplatesApiFp(this.configuration).deleteAccessRequestTemplate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get access request template by ID
     * @param {AccessRequestTemplatesApiGetAccessRequestTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestTemplatesApi
     */
    public getAccessRequestTemplate(requestParameters: AccessRequestTemplatesApiGetAccessRequestTemplateRequest, options?: AxiosRequestConfig) {
        return AccessRequestTemplatesApiFp(this.configuration).getAccessRequestTemplate(requestParameters.id, requestParameters.filterAvailable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List access request templates
     * @param {AccessRequestTemplatesApiListAccessRequestTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestTemplatesApi
     */
    public listAccessRequestTemplates(requestParameters: AccessRequestTemplatesApiListAccessRequestTemplatesRequest = {}, options?: AxiosRequestConfig) {
        return AccessRequestTemplatesApiFp(this.configuration).listAccessRequestTemplates(requestParameters.limit, requestParameters.search, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update access request template
     * @param {AccessRequestTemplatesApiUpdateAccessRequestTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestTemplatesApi
     */
    public updateAccessRequestTemplate(requestParameters: AccessRequestTemplatesApiUpdateAccessRequestTemplateRequest, options?: AxiosRequestConfig) {
        return AccessRequestTemplatesApiFp(this.configuration).updateAccessRequestTemplate(requestParameters.id, requestParameters.createAndUpdateAccessRequestTemplateClientModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccessRequestsApi - axios parameter creator
 * @export
 */
export const AccessRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve access request
         * @param {string} id 
         * @param {ApprovalResultClientModel} approvalResultClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAccessRequest: async (id: string, approvalResultClientModel: ApprovalResultClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveAccessRequest', 'id', id)
            // verify required parameter 'approvalResultClientModel' is not null or undefined
            assertParamExists('approveAccessRequest', 'approvalResultClientModel', approvalResultClientModel)
            const localVarPath = `/api/client/v1/access-requests/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approvalResultClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create user access request
         * @param {CreateAccessRequestClientModel} createAccessRequestClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccessRequest: async (createAccessRequestClientModel: CreateAccessRequestClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAccessRequestClientModel' is not null or undefined
            assertParamExists('createUserAccessRequest', 'createAccessRequestClientModel', createAccessRequestClientModel)
            const localVarPath = `/api/client/v1/access-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccessRequestClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create user access request - dry run
         * @param {CreateAccessRequestClientModel} createAccessRequestClientModel 
         * @param {boolean} [resourceTypeOnlyMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunCreateUserAccessRequest: async (createAccessRequestClientModel: CreateAccessRequestClientModel, resourceTypeOnlyMode?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAccessRequestClientModel' is not null or undefined
            assertParamExists('dryRunCreateUserAccessRequest', 'createAccessRequestClientModel', createAccessRequestClientModel)
            const localVarPath = `/api/client/v1/access-requests/dry-run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (resourceTypeOnlyMode !== undefined) {
                localVarQueryParameter['resource_type_only_mode'] = resourceTypeOnlyMode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccessRequestClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get access request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccessRequest', 'id', id)
            const localVarPath = `/api/client/v1/access-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List access requests
         * @param {AccessRequestsScopeModel} scope 
         * @param {boolean} [includeAutogrant] 
         * @param {number} [limit] 
         * @param {Array<string>} [requestIds] 
         * @param {number} [skip] 
         * @param {Array<string>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessRequests: async (scope: AccessRequestsScopeModel, includeAutogrant?: boolean, limit?: number, requestIds?: Array<string>, skip?: number, statuses?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('listAccessRequests', 'scope', scope)
            const localVarPath = `/api/client/v1/access-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeAutogrant !== undefined) {
                localVarQueryParameter['include_autogrant'] = includeAutogrant;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (requestIds) {
                localVarQueryParameter['request_ids'] = requestIds;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passMfaForAccessRequests: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/access-requests/pass-mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject access request
         * @param {string} id 
         * @param {ApprovalResultClientModel} approvalResultClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAccessRequest: async (id: string, approvalResultClientModel: ApprovalResultClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectAccessRequest', 'id', id)
            // verify required parameter 'approvalResultClientModel' is not null or undefined
            assertParamExists('rejectAccessRequest', 'approvalResultClientModel', approvalResultClientModel)
            const localVarPath = `/api/client/v1/access-requests/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approvalResultClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request again access request
         * @param {string} id 
         * @param {RequestAgainClientModel} requestAgainClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAgainAccessRequest: async (id: string, requestAgainClientModel: RequestAgainClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('requestAgainAccessRequest', 'id', id)
            // verify required parameter 'requestAgainClientModel' is not null or undefined
            assertParamExists('requestAgainAccessRequest', 'requestAgainClientModel', requestAgainClientModel)
            const localVarPath = `/api/client/v1/access-requests/{id}/request-again`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestAgainClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke access request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccessRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revokeAccessRequest', 'id', id)
            const localVarPath = `/api/client/v1/access-requests/{id}/revoke`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessRequestsApi - functional programming interface
 * @export
 */
export const AccessRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve access request
         * @param {string} id 
         * @param {ApprovalResultClientModel} approvalResultClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAccessRequest(id: string, approvalResultClientModel: ApprovalResultClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAccessRequest(id, approvalResultClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create user access request
         * @param {CreateAccessRequestClientModel} createAccessRequestClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserAccessRequest(createAccessRequestClientModel: CreateAccessRequestClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestSubmittedClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserAccessRequest(createAccessRequestClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create user access request - dry run
         * @param {CreateAccessRequestClientModel} createAccessRequestClientModel 
         * @param {boolean} [resourceTypeOnlyMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRunCreateUserAccessRequest(createAccessRequestClientModel: CreateAccessRequestClientModel, resourceTypeOnlyMode?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DryRunClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRunCreateUserAccessRequest(createAccessRequestClientModel, resourceTypeOnlyMode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get access request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List access requests
         * @param {AccessRequestsScopeModel} scope 
         * @param {boolean} [includeAutogrant] 
         * @param {number} [limit] 
         * @param {Array<string>} [requestIds] 
         * @param {number} [skip] 
         * @param {Array<string>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessRequests(scope: AccessRequestsScopeModel, includeAutogrant?: boolean, limit?: number, requestIds?: Array<string>, skip?: number, statuses?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelAccessRequestClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessRequests(scope, includeAutogrant, limit, requestIds, skip, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passMfaForAccessRequests(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PassMfaClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passMfaForAccessRequests(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject access request
         * @param {string} id 
         * @param {ApprovalResultClientModel} approvalResultClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectAccessRequest(id: string, approvalResultClientModel: ApprovalResultClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectAccessRequest(id, approvalResultClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary request again access request
         * @param {string} id 
         * @param {RequestAgainClientModel} requestAgainClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAgainAccessRequest(id: string, requestAgainClientModel: RequestAgainClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestSubmittedClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAgainAccessRequest(id, requestAgainClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revoke access request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAccessRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAccessRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccessRequestsApi - factory interface
 * @export
 */
export const AccessRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve access request
         * @param {AccessRequestsApiApproveAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAccessRequest(requestParameters: AccessRequestsApiApproveAccessRequestRequest, options?: AxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.approveAccessRequest(requestParameters.id, requestParameters.approvalResultClientModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create user access request
         * @param {AccessRequestsApiCreateUserAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccessRequest(requestParameters: AccessRequestsApiCreateUserAccessRequestRequest, options?: AxiosRequestConfig): AxiosPromise<AccessRequestSubmittedClientResponse> {
            return localVarFp.createUserAccessRequest(requestParameters.createAccessRequestClientModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create user access request - dry run
         * @param {AccessRequestsApiDryRunCreateUserAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunCreateUserAccessRequest(requestParameters: AccessRequestsApiDryRunCreateUserAccessRequestRequest, options?: AxiosRequestConfig): AxiosPromise<DryRunClientResponse> {
            return localVarFp.dryRunCreateUserAccessRequest(requestParameters.createAccessRequestClientModel, requestParameters.resourceTypeOnlyMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get access request
         * @param {AccessRequestsApiGetAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequest(requestParameters: AccessRequestsApiGetAccessRequestRequest, options?: AxiosRequestConfig): AxiosPromise<AccessRequestClientModel> {
            return localVarFp.getAccessRequest(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List access requests
         * @param {AccessRequestsApiListAccessRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessRequests(requestParameters: AccessRequestsApiListAccessRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelAccessRequestClientModel> {
            return localVarFp.listAccessRequests(requestParameters.scope, requestParameters.includeAutogrant, requestParameters.limit, requestParameters.requestIds, requestParameters.skip, requestParameters.statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passMfaForAccessRequests(options?: AxiosRequestConfig): AxiosPromise<PassMfaClientResponse> {
            return localVarFp.passMfaForAccessRequests(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject access request
         * @param {AccessRequestsApiRejectAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAccessRequest(requestParameters: AccessRequestsApiRejectAccessRequestRequest, options?: AxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.rejectAccessRequest(requestParameters.id, requestParameters.approvalResultClientModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request again access request
         * @param {AccessRequestsApiRequestAgainAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAgainAccessRequest(requestParameters: AccessRequestsApiRequestAgainAccessRequestRequest, options?: AxiosRequestConfig): AxiosPromise<AccessRequestSubmittedClientResponse> {
            return localVarFp.requestAgainAccessRequest(requestParameters.id, requestParameters.requestAgainClientModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke access request
         * @param {AccessRequestsApiRevokeAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccessRequest(requestParameters: AccessRequestsApiRevokeAccessRequestRequest, options?: AxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.revokeAccessRequest(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveAccessRequest operation in AccessRequestsApi.
 * @export
 * @interface AccessRequestsApiApproveAccessRequestRequest
 */
export interface AccessRequestsApiApproveAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsApiApproveAccessRequest
     */
    readonly id: string

    /**
     * 
     * @type {ApprovalResultClientModel}
     * @memberof AccessRequestsApiApproveAccessRequest
     */
    readonly approvalResultClientModel: ApprovalResultClientModel
}

/**
 * Request parameters for createUserAccessRequest operation in AccessRequestsApi.
 * @export
 * @interface AccessRequestsApiCreateUserAccessRequestRequest
 */
export interface AccessRequestsApiCreateUserAccessRequestRequest {
    /**
     * 
     * @type {CreateAccessRequestClientModel}
     * @memberof AccessRequestsApiCreateUserAccessRequest
     */
    readonly createAccessRequestClientModel: CreateAccessRequestClientModel
}

/**
 * Request parameters for dryRunCreateUserAccessRequest operation in AccessRequestsApi.
 * @export
 * @interface AccessRequestsApiDryRunCreateUserAccessRequestRequest
 */
export interface AccessRequestsApiDryRunCreateUserAccessRequestRequest {
    /**
     * 
     * @type {CreateAccessRequestClientModel}
     * @memberof AccessRequestsApiDryRunCreateUserAccessRequest
     */
    readonly createAccessRequestClientModel: CreateAccessRequestClientModel

    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestsApiDryRunCreateUserAccessRequest
     */
    readonly resourceTypeOnlyMode?: boolean
}

/**
 * Request parameters for getAccessRequest operation in AccessRequestsApi.
 * @export
 * @interface AccessRequestsApiGetAccessRequestRequest
 */
export interface AccessRequestsApiGetAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsApiGetAccessRequest
     */
    readonly id: string
}

/**
 * Request parameters for listAccessRequests operation in AccessRequestsApi.
 * @export
 * @interface AccessRequestsApiListAccessRequestsRequest
 */
export interface AccessRequestsApiListAccessRequestsRequest {
    /**
     * 
     * @type {AccessRequestsScopeModel}
     * @memberof AccessRequestsApiListAccessRequests
     */
    readonly scope: AccessRequestsScopeModel

    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestsApiListAccessRequests
     */
    readonly includeAutogrant?: boolean

    /**
     * 
     * @type {number}
     * @memberof AccessRequestsApiListAccessRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessRequestsApiListAccessRequests
     */
    readonly requestIds?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof AccessRequestsApiListAccessRequests
     */
    readonly skip?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessRequestsApiListAccessRequests
     */
    readonly statuses?: Array<string>
}

/**
 * Request parameters for rejectAccessRequest operation in AccessRequestsApi.
 * @export
 * @interface AccessRequestsApiRejectAccessRequestRequest
 */
export interface AccessRequestsApiRejectAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsApiRejectAccessRequest
     */
    readonly id: string

    /**
     * 
     * @type {ApprovalResultClientModel}
     * @memberof AccessRequestsApiRejectAccessRequest
     */
    readonly approvalResultClientModel: ApprovalResultClientModel
}

/**
 * Request parameters for requestAgainAccessRequest operation in AccessRequestsApi.
 * @export
 * @interface AccessRequestsApiRequestAgainAccessRequestRequest
 */
export interface AccessRequestsApiRequestAgainAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsApiRequestAgainAccessRequest
     */
    readonly id: string

    /**
     * 
     * @type {RequestAgainClientModel}
     * @memberof AccessRequestsApiRequestAgainAccessRequest
     */
    readonly requestAgainClientModel: RequestAgainClientModel
}

/**
 * Request parameters for revokeAccessRequest operation in AccessRequestsApi.
 * @export
 * @interface AccessRequestsApiRevokeAccessRequestRequest
 */
export interface AccessRequestsApiRevokeAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsApiRevokeAccessRequest
     */
    readonly id: string
}

/**
 * AccessRequestsApi - object-oriented interface
 * @export
 * @class AccessRequestsApi
 * @extends {BaseAPI}
 */
export class AccessRequestsApi extends BaseAPI {
    /**
     * 
     * @summary Approve access request
     * @param {AccessRequestsApiApproveAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public approveAccessRequest(requestParameters: AccessRequestsApiApproveAccessRequestRequest, options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).approveAccessRequest(requestParameters.id, requestParameters.approvalResultClientModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create user access request
     * @param {AccessRequestsApiCreateUserAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public createUserAccessRequest(requestParameters: AccessRequestsApiCreateUserAccessRequestRequest, options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).createUserAccessRequest(requestParameters.createAccessRequestClientModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create user access request - dry run
     * @param {AccessRequestsApiDryRunCreateUserAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public dryRunCreateUserAccessRequest(requestParameters: AccessRequestsApiDryRunCreateUserAccessRequestRequest, options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).dryRunCreateUserAccessRequest(requestParameters.createAccessRequestClientModel, requestParameters.resourceTypeOnlyMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get access request
     * @param {AccessRequestsApiGetAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public getAccessRequest(requestParameters: AccessRequestsApiGetAccessRequestRequest, options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).getAccessRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List access requests
     * @param {AccessRequestsApiListAccessRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public listAccessRequests(requestParameters: AccessRequestsApiListAccessRequestsRequest, options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).listAccessRequests(requestParameters.scope, requestParameters.includeAutogrant, requestParameters.limit, requestParameters.requestIds, requestParameters.skip, requestParameters.statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public passMfaForAccessRequests(options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).passMfaForAccessRequests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject access request
     * @param {AccessRequestsApiRejectAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public rejectAccessRequest(requestParameters: AccessRequestsApiRejectAccessRequestRequest, options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).rejectAccessRequest(requestParameters.id, requestParameters.approvalResultClientModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request again access request
     * @param {AccessRequestsApiRequestAgainAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public requestAgainAccessRequest(requestParameters: AccessRequestsApiRequestAgainAccessRequestRequest, options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).requestAgainAccessRequest(requestParameters.id, requestParameters.requestAgainClientModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke access request
     * @param {AccessRequestsApiRevokeAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public revokeAccessRequest(requestParameters: AccessRequestsApiRevokeAccessRequestRequest, options?: AxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).revokeAccessRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccessSessionsApi - axios parameter creator
 * @export
 */
export const AccessSessionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get access session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessSession: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccessSession', 'id', id)
            const localVarPath = `/api/client/v1/access-sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get access session details
         * @param {string} id 
         * @param {string} [formatType] 
         * @param {object} [aponoSec] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessSessionAccessDetails: async (id: string, formatType?: string, aponoSec?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccessSessionAccessDetails', 'id', id)
            const localVarPath = `/api/client/v1/access-sessions/{id}/access-details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (formatType !== undefined) {
                localVarQueryParameter['format_type'] = formatType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get access session request template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessSessionRequestTemplate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccessSessionRequestTemplate', 'id', id)
            const localVarPath = `/api/client/v1/access-sessions/{id}/request-template`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List access sessions
         * @param {Array<string>} [bundleId] 
         * @param {Array<string>} [credentialsId] 
         * @param {boolean} [includeDisconnected] 
         * @param {Array<string>} [integrationId] 
         * @param {Array<string>} [integrationTypes] 
         * @param {number} [limit] 
         * @param {Array<string>} [requestId] 
         * @param {string} [search] 
         * @param {Array<string>} [sessionTypes] 
         * @param {number} [skip] 
         * @param {Array<string>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessSessions: async (bundleId?: Array<string>, credentialsId?: Array<string>, includeDisconnected?: boolean, integrationId?: Array<string>, integrationTypes?: Array<string>, limit?: number, requestId?: Array<string>, search?: string, sessionTypes?: Array<string>, skip?: number, status?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/access-sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bundleId) {
                localVarQueryParameter['bundle_id'] = bundleId;
            }

            if (credentialsId) {
                localVarQueryParameter['credentials_id'] = credentialsId;
            }

            if (includeDisconnected !== undefined) {
                localVarQueryParameter['include_disconnected'] = includeDisconnected;
            }

            if (integrationId) {
                localVarQueryParameter['integration_id'] = integrationId;
            }

            if (integrationTypes) {
                localVarQueryParameter['integration_types'] = integrationTypes;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (requestId) {
                localVarQueryParameter['request_id'] = requestId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sessionTypes) {
                localVarQueryParameter['session_types'] = sessionTypes;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List access sessions groups
         * @param {boolean} [includeDisconnected] 
         * @param {Array<string>} [integrationId] 
         * @param {Array<string>} [integrationTypes] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {Array<string>} [sessionTypes] 
         * @param {number} [sessionsPageSize] 
         * @param {number} [skip] 
         * @param {Array<string>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessSessionsGroups: async (includeDisconnected?: boolean, integrationId?: Array<string>, integrationTypes?: Array<string>, limit?: number, search?: string, sessionTypes?: Array<string>, sessionsPageSize?: number, skip?: number, status?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/access-session-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeDisconnected !== undefined) {
                localVarQueryParameter['include_disconnected'] = includeDisconnected;
            }

            if (integrationId) {
                localVarQueryParameter['integration_id'] = integrationId;
            }

            if (integrationTypes) {
                localVarQueryParameter['integration_types'] = integrationTypes;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sessionTypes) {
                localVarQueryParameter['session_types'] = sessionTypes;
            }

            if (sessionsPageSize !== undefined) {
                localVarQueryParameter['sessions-page-size'] = sessionsPageSize;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset access session credentials
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAccessSessionCredentials: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetAccessSessionCredentials', 'id', id)
            const localVarPath = `/api/client/v1/access-sessions/{id}/reset-credentials`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync available sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAvailableSessions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/access-session-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessSessionsApi - functional programming interface
 * @export
 */
export const AccessSessionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessSessionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get access session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessSession(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessSessionClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessSession(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get access session details
         * @param {string} id 
         * @param {string} [formatType] 
         * @param {object} [aponoSec] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessSessionAccessDetails(id: string, formatType?: string, aponoSec?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessSessionDetailsClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessSessionAccessDetails(id, formatType, aponoSec, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get access session request template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessSessionRequestTemplate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessSessionRequestTemplateClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessSessionRequestTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List access sessions
         * @param {Array<string>} [bundleId] 
         * @param {Array<string>} [credentialsId] 
         * @param {boolean} [includeDisconnected] 
         * @param {Array<string>} [integrationId] 
         * @param {Array<string>} [integrationTypes] 
         * @param {number} [limit] 
         * @param {Array<string>} [requestId] 
         * @param {string} [search] 
         * @param {Array<string>} [sessionTypes] 
         * @param {number} [skip] 
         * @param {Array<string>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessSessions(bundleId?: Array<string>, credentialsId?: Array<string>, includeDisconnected?: boolean, integrationId?: Array<string>, integrationTypes?: Array<string>, limit?: number, requestId?: Array<string>, search?: string, sessionTypes?: Array<string>, skip?: number, status?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelAccessSessionClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessSessions(bundleId, credentialsId, includeDisconnected, integrationId, integrationTypes, limit, requestId, search, sessionTypes, skip, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List access sessions groups
         * @param {boolean} [includeDisconnected] 
         * @param {Array<string>} [integrationId] 
         * @param {Array<string>} [integrationTypes] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {Array<string>} [sessionTypes] 
         * @param {number} [sessionsPageSize] 
         * @param {number} [skip] 
         * @param {Array<string>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessSessionsGroups(includeDisconnected?: boolean, integrationId?: Array<string>, integrationTypes?: Array<string>, limit?: number, search?: string, sessionTypes?: Array<string>, sessionsPageSize?: number, skip?: number, status?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelAccessSessionsGroupClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessSessionsGroups(includeDisconnected, integrationId, integrationTypes, limit, search, sessionTypes, sessionsPageSize, skip, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset access session credentials
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetAccessSessionCredentials(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetAccessSessionCredentials(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync available sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAvailableSessions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAvailableSessions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccessSessionsApi - factory interface
 * @export
 */
export const AccessSessionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessSessionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get access session
         * @param {AccessSessionsApiGetAccessSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessSession(requestParameters: AccessSessionsApiGetAccessSessionRequest, options?: AxiosRequestConfig): AxiosPromise<AccessSessionClientModel> {
            return localVarFp.getAccessSession(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get access session details
         * @param {AccessSessionsApiGetAccessSessionAccessDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessSessionAccessDetails(requestParameters: AccessSessionsApiGetAccessSessionAccessDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<AccessSessionDetailsClientModel> {
            return localVarFp.getAccessSessionAccessDetails(requestParameters.id, requestParameters.formatType, requestParameters.aponoSec, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get access session request template
         * @param {AccessSessionsApiGetAccessSessionRequestTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessSessionRequestTemplate(requestParameters: AccessSessionsApiGetAccessSessionRequestTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<AccessSessionRequestTemplateClientModel> {
            return localVarFp.getAccessSessionRequestTemplate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List access sessions
         * @param {AccessSessionsApiListAccessSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessSessions(requestParameters: AccessSessionsApiListAccessSessionsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelAccessSessionClientModel> {
            return localVarFp.listAccessSessions(requestParameters.bundleId, requestParameters.credentialsId, requestParameters.includeDisconnected, requestParameters.integrationId, requestParameters.integrationTypes, requestParameters.limit, requestParameters.requestId, requestParameters.search, requestParameters.sessionTypes, requestParameters.skip, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List access sessions groups
         * @param {AccessSessionsApiListAccessSessionsGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessSessionsGroups(requestParameters: AccessSessionsApiListAccessSessionsGroupsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelAccessSessionsGroupClientModel> {
            return localVarFp.listAccessSessionsGroups(requestParameters.includeDisconnected, requestParameters.integrationId, requestParameters.integrationTypes, requestParameters.limit, requestParameters.search, requestParameters.sessionTypes, requestParameters.sessionsPageSize, requestParameters.skip, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset access session credentials
         * @param {AccessSessionsApiResetAccessSessionCredentialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAccessSessionCredentials(requestParameters: AccessSessionsApiResetAccessSessionCredentialsRequest, options?: AxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.resetAccessSessionCredentials(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync available sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAvailableSessions(options?: AxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.syncAvailableSessions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAccessSession operation in AccessSessionsApi.
 * @export
 * @interface AccessSessionsApiGetAccessSessionRequest
 */
export interface AccessSessionsApiGetAccessSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessSessionsApiGetAccessSession
     */
    readonly id: string
}

/**
 * Request parameters for getAccessSessionAccessDetails operation in AccessSessionsApi.
 * @export
 * @interface AccessSessionsApiGetAccessSessionAccessDetailsRequest
 */
export interface AccessSessionsApiGetAccessSessionAccessDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessSessionsApiGetAccessSessionAccessDetails
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AccessSessionsApiGetAccessSessionAccessDetails
     */
    readonly formatType?: string

    /**
     * 
     * @type {object}
     * @memberof AccessSessionsApiGetAccessSessionAccessDetails
     */
    readonly aponoSec?: object
}

/**
 * Request parameters for getAccessSessionRequestTemplate operation in AccessSessionsApi.
 * @export
 * @interface AccessSessionsApiGetAccessSessionRequestTemplateRequest
 */
export interface AccessSessionsApiGetAccessSessionRequestTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessSessionsApiGetAccessSessionRequestTemplate
     */
    readonly id: string
}

/**
 * Request parameters for listAccessSessions operation in AccessSessionsApi.
 * @export
 * @interface AccessSessionsApiListAccessSessionsRequest
 */
export interface AccessSessionsApiListAccessSessionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly bundleId?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly credentialsId?: Array<string>

    /**
     * 
     * @type {boolean}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly includeDisconnected?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly integrationId?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly integrationTypes?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly limit?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly requestId?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly search?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly sessionTypes?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly skip?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessions
     */
    readonly status?: Array<string>
}

/**
 * Request parameters for listAccessSessionsGroups operation in AccessSessionsApi.
 * @export
 * @interface AccessSessionsApiListAccessSessionsGroupsRequest
 */
export interface AccessSessionsApiListAccessSessionsGroupsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly includeDisconnected?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly integrationId?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly integrationTypes?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly search?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly sessionTypes?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly sessionsPageSize?: number

    /**
     * 
     * @type {number}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly skip?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessSessionsApiListAccessSessionsGroups
     */
    readonly status?: Array<string>
}

/**
 * Request parameters for resetAccessSessionCredentials operation in AccessSessionsApi.
 * @export
 * @interface AccessSessionsApiResetAccessSessionCredentialsRequest
 */
export interface AccessSessionsApiResetAccessSessionCredentialsRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessSessionsApiResetAccessSessionCredentials
     */
    readonly id: string
}

/**
 * AccessSessionsApi - object-oriented interface
 * @export
 * @class AccessSessionsApi
 * @extends {BaseAPI}
 */
export class AccessSessionsApi extends BaseAPI {
    /**
     * 
     * @summary Get access session
     * @param {AccessSessionsApiGetAccessSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessSessionsApi
     */
    public getAccessSession(requestParameters: AccessSessionsApiGetAccessSessionRequest, options?: AxiosRequestConfig) {
        return AccessSessionsApiFp(this.configuration).getAccessSession(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get access session details
     * @param {AccessSessionsApiGetAccessSessionAccessDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessSessionsApi
     */
    public getAccessSessionAccessDetails(requestParameters: AccessSessionsApiGetAccessSessionAccessDetailsRequest, options?: AxiosRequestConfig) {
        return AccessSessionsApiFp(this.configuration).getAccessSessionAccessDetails(requestParameters.id, requestParameters.formatType, requestParameters.aponoSec, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get access session request template
     * @param {AccessSessionsApiGetAccessSessionRequestTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessSessionsApi
     */
    public getAccessSessionRequestTemplate(requestParameters: AccessSessionsApiGetAccessSessionRequestTemplateRequest, options?: AxiosRequestConfig) {
        return AccessSessionsApiFp(this.configuration).getAccessSessionRequestTemplate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List access sessions
     * @param {AccessSessionsApiListAccessSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessSessionsApi
     */
    public listAccessSessions(requestParameters: AccessSessionsApiListAccessSessionsRequest = {}, options?: AxiosRequestConfig) {
        return AccessSessionsApiFp(this.configuration).listAccessSessions(requestParameters.bundleId, requestParameters.credentialsId, requestParameters.includeDisconnected, requestParameters.integrationId, requestParameters.integrationTypes, requestParameters.limit, requestParameters.requestId, requestParameters.search, requestParameters.sessionTypes, requestParameters.skip, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List access sessions groups
     * @param {AccessSessionsApiListAccessSessionsGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessSessionsApi
     */
    public listAccessSessionsGroups(requestParameters: AccessSessionsApiListAccessSessionsGroupsRequest = {}, options?: AxiosRequestConfig) {
        return AccessSessionsApiFp(this.configuration).listAccessSessionsGroups(requestParameters.includeDisconnected, requestParameters.integrationId, requestParameters.integrationTypes, requestParameters.limit, requestParameters.search, requestParameters.sessionTypes, requestParameters.sessionsPageSize, requestParameters.skip, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset access session credentials
     * @param {AccessSessionsApiResetAccessSessionCredentialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessSessionsApi
     */
    public resetAccessSessionCredentials(requestParameters: AccessSessionsApiResetAccessSessionCredentialsRequest, options?: AxiosRequestConfig) {
        return AccessSessionsApiFp(this.configuration).resetAccessSessionCredentials(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync available sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessSessionsApi
     */
    public syncAvailableSessions(options?: AxiosRequestConfig) {
        return AccessSessionsApiFp(this.configuration).syncAvailableSessions(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserPersonalTokenRequestClientModel} createUserPersonalTokenRequestClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateUserToken: async (createUserPersonalTokenRequestClientModel: CreateUserPersonalTokenRequestClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserPersonalTokenRequestClientModel' is not null or undefined
            assertParamExists('clientCreateUserToken', 'createUserPersonalTokenRequestClientModel', createUserPersonalTokenRequestClientModel)
            const localVarPath = `/api/client/v1/personal-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserPersonalTokenRequestClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientDeleteUserToken: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientDeleteUserToken', 'id', id)
            const localVarPath = `/api/client/v1/personal-tokens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetUserToken: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientGetUserToken', 'id', id)
            const localVarPath = `/api/client/v1/personal-tokens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientListUserTokens: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/personal-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateExpiryRequestClientModel} updateExpiryRequestClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUpdateUserTokenExpiry: async (id: string, updateExpiryRequestClientModel: UpdateExpiryRequestClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clientUpdateUserTokenExpiry', 'id', id)
            // verify required parameter 'updateExpiryRequestClientModel' is not null or undefined
            assertParamExists('clientUpdateUserTokenExpiry', 'updateExpiryRequestClientModel', updateExpiryRequestClientModel)
            const localVarPath = `/api/client/v1/personal-tokens/{id}/expiry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExpiryRequestClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUserPersonalTokenRequestClientModel} createUserPersonalTokenRequestClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCreateUserToken(createUserPersonalTokenRequestClientModel: CreateUserPersonalTokenRequestClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Unmasked>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCreateUserToken(createUserPersonalTokenRequestClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientDeleteUserToken(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientDeleteUserToken(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetUserToken(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPersonalToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetUserToken(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientListUserTokens(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserPersonalToken>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientListUserTokens(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateExpiryRequestClientModel} updateExpiryRequestClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientUpdateUserTokenExpiry(id: string, updateExpiryRequestClientModel: UpdateExpiryRequestClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Unmasked>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientUpdateUserTokenExpiry(id, updateExpiryRequestClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsApiFp(configuration)
    return {
        /**
         * 
         * @param {AccountsApiClientCreateUserTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateUserToken(requestParameters: AccountsApiClientCreateUserTokenRequest, options?: AxiosRequestConfig): AxiosPromise<Unmasked> {
            return localVarFp.clientCreateUserToken(requestParameters.createUserPersonalTokenRequestClientModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountsApiClientDeleteUserTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientDeleteUserToken(requestParameters: AccountsApiClientDeleteUserTokenRequest, options?: AxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.clientDeleteUserToken(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountsApiClientGetUserTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetUserToken(requestParameters: AccountsApiClientGetUserTokenRequest, options?: AxiosRequestConfig): AxiosPromise<UserPersonalToken> {
            return localVarFp.clientGetUserToken(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientListUserTokens(options?: AxiosRequestConfig): AxiosPromise<Array<UserPersonalToken>> {
            return localVarFp.clientListUserTokens(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountsApiClientUpdateUserTokenExpiryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUpdateUserTokenExpiry(requestParameters: AccountsApiClientUpdateUserTokenExpiryRequest, options?: AxiosRequestConfig): AxiosPromise<Unmasked> {
            return localVarFp.clientUpdateUserTokenExpiry(requestParameters.id, requestParameters.updateExpiryRequestClientModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for clientCreateUserToken operation in AccountsApi.
 * @export
 * @interface AccountsApiClientCreateUserTokenRequest
 */
export interface AccountsApiClientCreateUserTokenRequest {
    /**
     * 
     * @type {CreateUserPersonalTokenRequestClientModel}
     * @memberof AccountsApiClientCreateUserToken
     */
    readonly createUserPersonalTokenRequestClientModel: CreateUserPersonalTokenRequestClientModel
}

/**
 * Request parameters for clientDeleteUserToken operation in AccountsApi.
 * @export
 * @interface AccountsApiClientDeleteUserTokenRequest
 */
export interface AccountsApiClientDeleteUserTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountsApiClientDeleteUserToken
     */
    readonly id: string
}

/**
 * Request parameters for clientGetUserToken operation in AccountsApi.
 * @export
 * @interface AccountsApiClientGetUserTokenRequest
 */
export interface AccountsApiClientGetUserTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountsApiClientGetUserToken
     */
    readonly id: string
}

/**
 * Request parameters for clientUpdateUserTokenExpiry operation in AccountsApi.
 * @export
 * @interface AccountsApiClientUpdateUserTokenExpiryRequest
 */
export interface AccountsApiClientUpdateUserTokenExpiryRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountsApiClientUpdateUserTokenExpiry
     */
    readonly id: string

    /**
     * 
     * @type {UpdateExpiryRequestClientModel}
     * @memberof AccountsApiClientUpdateUserTokenExpiry
     */
    readonly updateExpiryRequestClientModel: UpdateExpiryRequestClientModel
}

/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     * 
     * @param {AccountsApiClientCreateUserTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public clientCreateUserToken(requestParameters: AccountsApiClientCreateUserTokenRequest, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).clientCreateUserToken(requestParameters.createUserPersonalTokenRequestClientModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountsApiClientDeleteUserTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public clientDeleteUserToken(requestParameters: AccountsApiClientDeleteUserTokenRequest, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).clientDeleteUserToken(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountsApiClientGetUserTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public clientGetUserToken(requestParameters: AccountsApiClientGetUserTokenRequest, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).clientGetUserToken(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public clientListUserTokens(options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).clientListUserTokens(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountsApiClientUpdateUserTokenExpiryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public clientUpdateUserTokenExpiry(requestParameters: AccountsApiClientUpdateUserTokenExpiryRequest, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).clientUpdateUserTokenExpiry(requestParameters.id, requestParameters.updateExpiryRequestClientModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Send analytics event
         * @param {CreateAnalyticEventClientModel} createAnalyticEventClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAnalyticsEvent: async (createAnalyticEventClientModel: CreateAnalyticEventClientModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAnalyticEventClientModel' is not null or undefined
            assertParamExists('sendAnalyticsEvent', 'createAnalyticEventClientModel', createAnalyticEventClientModel)
            const localVarPath = `/api/client/v1/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAnalyticEventClientModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Send analytics event
         * @param {CreateAnalyticEventClientModel} createAnalyticEventClientModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAnalyticsEvent(createAnalyticEventClientModel: CreateAnalyticEventClientModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAnalyticsEvent(createAnalyticEventClientModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Send analytics event
         * @param {AnalyticsApiSendAnalyticsEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAnalyticsEvent(requestParameters: AnalyticsApiSendAnalyticsEventRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendAnalyticsEvent(requestParameters.createAnalyticEventClientModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sendAnalyticsEvent operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiSendAnalyticsEventRequest
 */
export interface AnalyticsApiSendAnalyticsEventRequest {
    /**
     * 
     * @type {CreateAnalyticEventClientModel}
     * @memberof AnalyticsApiSendAnalyticsEvent
     */
    readonly createAnalyticEventClientModel: CreateAnalyticEventClientModel
}

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * 
     * @summary Send analytics event
     * @param {AnalyticsApiSendAnalyticsEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public sendAnalyticsEvent(requestParameters: AnalyticsApiSendAnalyticsEventRequest, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).sendAnalyticsEvent(requestParameters.createAnalyticEventClientModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FiltersApi - axios parameter creator
 * @export
 */
export const FiltersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List integration filters
         * @param {number} [limit] 
         * @param {string} [scope] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntegrationFilterOptions: async (limit?: number, scope?: string, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/filters/integrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiltersApi - functional programming interface
 * @export
 */
export const FiltersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FiltersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List integration filters
         * @param {number} [limit] 
         * @param {string} [scope] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listIntegrationFilterOptions(limit?: number, scope?: string, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelIntegrationClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listIntegrationFilterOptions(limit, scope, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FiltersApi - factory interface
 * @export
 */
export const FiltersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FiltersApiFp(configuration)
    return {
        /**
         * 
         * @summary List integration filters
         * @param {FiltersApiListIntegrationFilterOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntegrationFilterOptions(requestParameters: FiltersApiListIntegrationFilterOptionsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelIntegrationClientModel> {
            return localVarFp.listIntegrationFilterOptions(requestParameters.limit, requestParameters.scope, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listIntegrationFilterOptions operation in FiltersApi.
 * @export
 * @interface FiltersApiListIntegrationFilterOptionsRequest
 */
export interface FiltersApiListIntegrationFilterOptionsRequest {
    /**
     * 
     * @type {number}
     * @memberof FiltersApiListIntegrationFilterOptions
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof FiltersApiListIntegrationFilterOptions
     */
    readonly scope?: string

    /**
     * 
     * @type {number}
     * @memberof FiltersApiListIntegrationFilterOptions
     */
    readonly skip?: number
}

/**
 * FiltersApi - object-oriented interface
 * @export
 * @class FiltersApi
 * @extends {BaseAPI}
 */
export class FiltersApi extends BaseAPI {
    /**
     * 
     * @summary List integration filters
     * @param {FiltersApiListIntegrationFilterOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersApi
     */
    public listIntegrationFilterOptions(requestParameters: FiltersApiListIntegrationFilterOptionsRequest = {}, options?: AxiosRequestConfig) {
        return FiltersApiFp(this.configuration).listIntegrationFilterOptions(requestParameters.limit, requestParameters.scope, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List access bundles
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessBundles: async (limit?: number, search?: string, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/inventory/bundles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List access units
         * @param {Array<string>} [bundleIds] 
         * @param {Array<string>} [integrationIds] 
         * @param {number} [limit] 
         * @param {Array<string>} [permissionIds] 
         * @param {Array<string>} [resourceIds] 
         * @param {Array<string>} [resourceTypeIds] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessUnits: async (bundleIds?: Array<string>, integrationIds?: Array<string>, limit?: number, permissionIds?: Array<string>, resourceIds?: Array<string>, resourceTypeIds?: Array<string>, search?: string, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/inventory/access-units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bundleIds) {
                localVarQueryParameter['bundle-ids'] = bundleIds;
            }

            if (integrationIds) {
                localVarQueryParameter['integration-ids'] = integrationIds;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (permissionIds) {
                localVarQueryParameter['permission-ids'] = permissionIds;
            }

            if (resourceIds) {
                localVarQueryParameter['resource-ids'] = resourceIds;
            }

            if (resourceTypeIds) {
                localVarQueryParameter['resource-type-ids'] = resourceTypeIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List integrations
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [sessionId] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntegration: async (limit?: number, search?: string, sessionId?: string, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/inventory/integrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List permissions
         * @param {string} [integrationId] 
         * @param {number} [limit] 
         * @param {string} [resourceTypeId] 
         * @param {string} [search] 
         * @param {string} [sessionId] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions: async (integrationId?: string, limit?: number, resourceTypeId?: string, search?: string, sessionId?: string, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/inventory/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationId !== undefined) {
                localVarQueryParameter['integration-id'] = integrationId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (resourceTypeId !== undefined) {
                localVarQueryParameter['resource-type-id'] = resourceTypeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List resource types
         * @param {string} [integrationId] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [sessionId] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceTypes: async (integrationId?: string, limit?: number, search?: string, sessionId?: string, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/inventory/resource-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationId !== undefined) {
                localVarQueryParameter['integration-id'] = integrationId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List resources
         * @param {string} [integrationId] 
         * @param {number} [limit] 
         * @param {string} [resourceTypeId] 
         * @param {string} [search] 
         * @param {string} [sessionId] 
         * @param {number} [skip] 
         * @param {Array<string>} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources: async (integrationId?: string, limit?: number, resourceTypeId?: string, search?: string, sessionId?: string, skip?: number, sourceId?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/inventory/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationId !== undefined) {
                localVarQueryParameter['integration-id'] = integrationId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (resourceTypeId !== undefined) {
                localVarQueryParameter['resource-type-id'] = resourceTypeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sourceId) {
                localVarQueryParameter['source-id'] = sourceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List access bundles
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessBundles(limit?: number, search?: string, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelBundleClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessBundles(limit, search, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List access units
         * @param {Array<string>} [bundleIds] 
         * @param {Array<string>} [integrationIds] 
         * @param {number} [limit] 
         * @param {Array<string>} [permissionIds] 
         * @param {Array<string>} [resourceIds] 
         * @param {Array<string>} [resourceTypeIds] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessUnits(bundleIds?: Array<string>, integrationIds?: Array<string>, limit?: number, permissionIds?: Array<string>, resourceIds?: Array<string>, resourceTypeIds?: Array<string>, search?: string, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelAccessUnitClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessUnits(bundleIds, integrationIds, limit, permissionIds, resourceIds, resourceTypeIds, search, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List integrations
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [sessionId] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listIntegration(limit?: number, search?: string, sessionId?: string, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelIntegrationClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listIntegration(limit, search, sessionId, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List permissions
         * @param {string} [integrationId] 
         * @param {number} [limit] 
         * @param {string} [resourceTypeId] 
         * @param {string} [search] 
         * @param {string} [sessionId] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPermissions(integrationId?: string, limit?: number, resourceTypeId?: string, search?: string, sessionId?: string, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelPermissionClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPermissions(integrationId, limit, resourceTypeId, search, sessionId, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List resource types
         * @param {string} [integrationId] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [sessionId] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listResourceTypes(integrationId?: string, limit?: number, search?: string, sessionId?: string, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelResourceTypeClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listResourceTypes(integrationId, limit, search, sessionId, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List resources
         * @param {string} [integrationId] 
         * @param {number} [limit] 
         * @param {string} [resourceTypeId] 
         * @param {string} [search] 
         * @param {string} [sessionId] 
         * @param {number} [skip] 
         * @param {Array<string>} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listResources(integrationId?: string, limit?: number, resourceTypeId?: string, search?: string, sessionId?: string, skip?: number, sourceId?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientResponseModelResourceClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listResources(integrationId, limit, resourceTypeId, search, sessionId, skip, sourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryApiFp(configuration)
    return {
        /**
         * 
         * @summary List access bundles
         * @param {InventoryApiListAccessBundlesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessBundles(requestParameters: InventoryApiListAccessBundlesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelBundleClientModel> {
            return localVarFp.listAccessBundles(requestParameters.limit, requestParameters.search, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List access units
         * @param {InventoryApiListAccessUnitsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessUnits(requestParameters: InventoryApiListAccessUnitsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelAccessUnitClientModel> {
            return localVarFp.listAccessUnits(requestParameters.bundleIds, requestParameters.integrationIds, requestParameters.limit, requestParameters.permissionIds, requestParameters.resourceIds, requestParameters.resourceTypeIds, requestParameters.search, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List integrations
         * @param {InventoryApiListIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntegration(requestParameters: InventoryApiListIntegrationRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelIntegrationClientModel> {
            return localVarFp.listIntegration(requestParameters.limit, requestParameters.search, requestParameters.sessionId, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List permissions
         * @param {InventoryApiListPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions(requestParameters: InventoryApiListPermissionsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelPermissionClientModel> {
            return localVarFp.listPermissions(requestParameters.integrationId, requestParameters.limit, requestParameters.resourceTypeId, requestParameters.search, requestParameters.sessionId, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List resource types
         * @param {InventoryApiListResourceTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResourceTypes(requestParameters: InventoryApiListResourceTypesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelResourceTypeClientModel> {
            return localVarFp.listResourceTypes(requestParameters.integrationId, requestParameters.limit, requestParameters.search, requestParameters.sessionId, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List resources
         * @param {InventoryApiListResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(requestParameters: InventoryApiListResourcesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedClientResponseModelResourceClientModel> {
            return localVarFp.listResources(requestParameters.integrationId, requestParameters.limit, requestParameters.resourceTypeId, requestParameters.search, requestParameters.sessionId, requestParameters.skip, requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listAccessBundles operation in InventoryApi.
 * @export
 * @interface InventoryApiListAccessBundlesRequest
 */
export interface InventoryApiListAccessBundlesRequest {
    /**
     * 
     * @type {number}
     * @memberof InventoryApiListAccessBundles
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListAccessBundles
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListAccessBundles
     */
    readonly skip?: number
}

/**
 * Request parameters for listAccessUnits operation in InventoryApi.
 * @export
 * @interface InventoryApiListAccessUnitsRequest
 */
export interface InventoryApiListAccessUnitsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InventoryApiListAccessUnits
     */
    readonly bundleIds?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof InventoryApiListAccessUnits
     */
    readonly integrationIds?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListAccessUnits
     */
    readonly limit?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof InventoryApiListAccessUnits
     */
    readonly permissionIds?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof InventoryApiListAccessUnits
     */
    readonly resourceIds?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof InventoryApiListAccessUnits
     */
    readonly resourceTypeIds?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListAccessUnits
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListAccessUnits
     */
    readonly skip?: number
}

/**
 * Request parameters for listIntegration operation in InventoryApi.
 * @export
 * @interface InventoryApiListIntegrationRequest
 */
export interface InventoryApiListIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof InventoryApiListIntegration
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListIntegration
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListIntegration
     */
    readonly sessionId?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListIntegration
     */
    readonly skip?: number
}

/**
 * Request parameters for listPermissions operation in InventoryApi.
 * @export
 * @interface InventoryApiListPermissionsRequest
 */
export interface InventoryApiListPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof InventoryApiListPermissions
     */
    readonly integrationId?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListPermissions
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListPermissions
     */
    readonly resourceTypeId?: string

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListPermissions
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListPermissions
     */
    readonly sessionId?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListPermissions
     */
    readonly skip?: number
}

/**
 * Request parameters for listResourceTypes operation in InventoryApi.
 * @export
 * @interface InventoryApiListResourceTypesRequest
 */
export interface InventoryApiListResourceTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof InventoryApiListResourceTypes
     */
    readonly integrationId?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListResourceTypes
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListResourceTypes
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListResourceTypes
     */
    readonly sessionId?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListResourceTypes
     */
    readonly skip?: number
}

/**
 * Request parameters for listResources operation in InventoryApi.
 * @export
 * @interface InventoryApiListResourcesRequest
 */
export interface InventoryApiListResourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof InventoryApiListResources
     */
    readonly integrationId?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListResources
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListResources
     */
    readonly resourceTypeId?: string

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListResources
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof InventoryApiListResources
     */
    readonly sessionId?: string

    /**
     * 
     * @type {number}
     * @memberof InventoryApiListResources
     */
    readonly skip?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof InventoryApiListResources
     */
    readonly sourceId?: Array<string>
}

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
    /**
     * 
     * @summary List access bundles
     * @param {InventoryApiListAccessBundlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listAccessBundles(requestParameters: InventoryApiListAccessBundlesRequest = {}, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listAccessBundles(requestParameters.limit, requestParameters.search, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List access units
     * @param {InventoryApiListAccessUnitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listAccessUnits(requestParameters: InventoryApiListAccessUnitsRequest = {}, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listAccessUnits(requestParameters.bundleIds, requestParameters.integrationIds, requestParameters.limit, requestParameters.permissionIds, requestParameters.resourceIds, requestParameters.resourceTypeIds, requestParameters.search, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List integrations
     * @param {InventoryApiListIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listIntegration(requestParameters: InventoryApiListIntegrationRequest = {}, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listIntegration(requestParameters.limit, requestParameters.search, requestParameters.sessionId, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List permissions
     * @param {InventoryApiListPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listPermissions(requestParameters: InventoryApiListPermissionsRequest = {}, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listPermissions(requestParameters.integrationId, requestParameters.limit, requestParameters.resourceTypeId, requestParameters.search, requestParameters.sessionId, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List resource types
     * @param {InventoryApiListResourceTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listResourceTypes(requestParameters: InventoryApiListResourceTypesRequest = {}, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listResourceTypes(requestParameters.integrationId, requestParameters.limit, requestParameters.search, requestParameters.sessionId, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List resources
     * @param {InventoryApiListResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listResources(requestParameters: InventoryApiListResourcesRequest = {}, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listResources(requestParameters.integrationId, requestParameters.limit, requestParameters.resourceTypeId, requestParameters.search, requestParameters.sessionId, requestParameters.skip, requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserSessionApi - axios parameter creator
 * @export
 */
export const UserSessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if user already enrolled MFA (added authenticator app) in Frontegg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isMfaEnrolled: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client/v1/session/is-mfa-enrolled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSessionApi - functional programming interface
 * @export
 */
export const UserSessionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSessionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSessionClientModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSession(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check if user already enrolled MFA (added authenticator app) in Frontegg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isMfaEnrolled(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMfaEnrolledResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isMfaEnrolled(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserSessionApi - factory interface
 * @export
 */
export const UserSessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSessionApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSession(options?: AxiosRequestConfig): AxiosPromise<UserSessionClientModel> {
            return localVarFp.getUserSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if user already enrolled MFA (added authenticator app) in Frontegg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isMfaEnrolled(options?: AxiosRequestConfig): AxiosPromise<UserMfaEnrolledResponse> {
            return localVarFp.isMfaEnrolled(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSessionApi - object-oriented interface
 * @export
 * @class UserSessionApi
 * @extends {BaseAPI}
 */
export class UserSessionApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSessionApi
     */
    public getUserSession(options?: AxiosRequestConfig) {
        return UserSessionApiFp(this.configuration).getUserSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if user already enrolled MFA (added authenticator app) in Frontegg
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSessionApi
     */
    public isMfaEnrolled(options?: AxiosRequestConfig) {
        return UserSessionApiFp(this.configuration).isMfaEnrolled(options).then((request) => request(this.axios, this.basePath));
    }
}


